<template>
  <div class="container p-30px border-grey02">
    <div class="flex justify-between items-center mb-30px">
      <div class="w-fit">
        <div class="flex items-center">
          <img
            :src="'/images/svg/projects/icon-list.svg'"
            class="h-30px mr-10px"
          />
          <h1 class="text-black01 font-medium">{{ title }}</h1>
        </div>
      </div>
      <div class=""></div>
      <div class="">
        <div class="">
          <template v-if="search">
            <span class="search-result-count">
              <span class="search-result-count-number">{{
                projects.total
              }}</span>
              {{ "件見つかりました" }}
            </span>
          </template>
          <template v-else>
            <div class="flex">
              <button
                class="block text-white00 text-xs px-20px leading-loose bg-grey04 rounded-20px"
                v-on:click="openSearchDialog"
              >
                {{ "案件検索" }}
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="container__content">
      <table class="project-table">
        <thead>
          <tr>
            <th>{{ "完了ID" }}</th>
            <th>{{ "年月" }}</th>
            <th>{{ "完了件数" }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ project_archive.friendly_id }}</td>
            <td>{{ formatISODate(project_archive.date, "yyyy/MM") }}</td>
            <td>{{ projects.total }}</td>
          </tr>
        </tbody>
      </table>

      <table class="project-table overflow-x-scroll">
        <thead>
          <tr>
            <th v-for="(header, index) in tableHeaders" v-bind:key="index">
              <template v-if="!header.sortable">
                {{ header.name }}
              </template>
              <template v-else>
                <a href="#" v-on:click="changeSort(header.key)">
                  {{ header.name }}
                </a>
                <i
                  class="fa"
                  v-bind:class="{
                    'fa-sort':
                      sortProperty != header.key ||
                      (sortDirection != 'asc' && sortDirection != 'desc'),
                    'fa-sort-up':
                      sortProperty == header.key && sortDirection == 'asc',
                    'fa-sort-down':
                      sortProperty == header.key && sortDirection == 'desc',
                  }"
                ></i>
              </template>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="project in projects.data" v-bind:key="project.id">
            <td class="w-1/10 min-w-100px">
              <a
                class="opacity decoration"
                :href="buildProjectShowUrl(project.id)"
                >{{ project.friendly_id }}</a
              >
            </td>
            <td class="w-1/6 min-w-150px">{{ project.customer ? project.customer.name : '' }}</td>
            <td class="w-1/3 min-w-150px">{{ project.name }}</td>
            <td class="w-1/10 min-w-100px">
              {{ formatISODate(project.due_date, "yyyy-MM-dd") }}
            </td>
            <td class="w-1/10 min-w-100px">
              <a v-if="project.bill"
                class="opacity decoration"
                :href="buildBillId(project.bill.id)"
                >{{ project.bill_friendly_id }}</a
              >
            </td>
            <td class="w-1/4 min-w-150px">{{ project.manager.name }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="container__footer">
      <div class="container__footer__block">
        <div>
          <div>
            <pagination
              :links="projects.links"
              :totalPages="projects.last_page"
            ></pagination>
          </div>
          <div v-if="search" class="footer-buttons">
            <a
              class="block text-white00 text-xs px-20px leading-loose bg-grey04 rounded-20px lg:mr-10px lg:mb-0 mb-10px"
              v-bind:href="urls.archiveShow"
              >{{ "一覧へ戻る" }}</a
            >
            <button
              class="block text-white00 text-xs px-20px leading-loose bg-grey04 rounded-20px"
              v-on:click="openSearchDialog"
            >
              {{ "検索条件変更" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <search-dialog
      :dialog-data="searchDialog"
      v-on:close-dialog="closeSearchDialog"
      v-on:submit-search="submitSearch"
    ></search-dialog>
  </div>
</template>

<style scoped>
a {
  color: #323232;
}
</style>

<script>
export default {
  props: {
    urls: Object,
    project_archive: Object,
    projects: Object,
    customersSearch: Array,
  },
  data() {
    return {
      tableHeaders: [
        {
          sortable: true,
          key: "friendly_id",
          name: "案件ID",
        },
        {
          sortable: true,
          key: "customer.name",
          name: "クライアント",
        },
        {
          sortable: true,
          key: "name",
          name: "案件名",
        },
        {
          sortable: true,
          key: "due_date",
          name: "納品日",
        },
        {
          sortable: true,
          key: "bill.friendly_id",
          name: "請求ID",
        },
        {
          sortable: true,
          key: "manager.name",
          name: "作成者",
        },
      ],
      sortProperty: null,
      sortDirection: null,
      search: false,
      searchDialog: {
        shown: false,
        title: "案件検索",
        submitLabel: "検索",
        fields: [
          {
            property: "friendly_id",
            label: "ID",
            type: "text",
            value: "",
            default: "",
            class: "full-width",
          },
          {
            property: "customer_id",
            label: "クライアント",
            type: "select",
            value: null,
            default: null,
            options: this.customersSearch,
            class: "w-full",
            cast: "integer",
          },
          {
            property: "name",
            label: "案件名",
            type: "text",
            value: "",
            default: "",
            class: "full-width",
          },
        ],
      },
    };
  },
  computed: {
    title: function () {
      return `${this.formatISODate(
        this.project_archive.date,
        "yyyy/MM"
      )}　案件完了`;
    },
  },
  methods: {
    buildProjectShowUrl: function (id) {
      return this.urls.projectShow.replace(/__PROJECT_ID__/g, id);
    },
    buildBillId: function (id) {
      return this.urls.billShow.replace(/__BILL_ID__/g, id);
    },
    openSearchDialog: function () {
      this.searchDialog.shown = true;
    },
    closeSearchDialog: function () {
      this.searchDialog.shown = false;
    },
    submitSearch: function () {
      //this.closeSearchDialog();
      var params = new URLSearchParams(window.location.search);
      params.set("search", true);
      this.searchDialog.fields.forEach((field) => {
        params.delete(field.property);
        if (
          field.value != null &&
          !Number.isNaN(field.value) &&
          field.value != ""
        ) {
          params.set(field.property, field.value);
        }
      });
      window.location.search = params.toString();
    },
    changeSort: function (sort_key) {
      var sortDirection = this.sortDirection;
      if (this.sortProperty != sort_key) {
        sortDirection = "null";
      }
      this.sortProperty = sort_key;
      switch (sortDirection) {
        case "null":
          this.sortDirection = "asc";
          break;
        case "asc":
          this.sortDirection = "desc";
          break;
        case "desc":
          this.sortProperty = null;
          this.sortDirection = null;
          break;
      }
      var params = new URLSearchParams(window.location.search);
      params.delete("page");
      if (this.sortProperty !== null) {
        params.set("sort", this.sortProperty);
        params.set("direction", this.sortDirection);
      } else {
        params.delete("sort");
        params.delete("direction");
      }
      window.location.search = params.toString();
    },
    navigate: function () {
      var params = new URLSearchParams(window.location.search);
      params.delete("page");
      window.location.search = params.toString();
    },
  },
  mounted() {
    var url = new URL(window.location.href);
    var params = new URLSearchParams(url.search);
    if (params.has("search")) {
      this.search = parseBoolean(params.get("search"));
    }
    if (params.has("sort")) {
      this.sortProperty = params.get("sort");
    }
    if (params.has("direction")) {
      this.sortDirection = params.get("direction");
    }
    this.searchDialog.fields.forEach((field) => {
      if (field.cast == "integer") {
        field.value = parseInt(params.get(field.property));
      } else {
        field.value = params.get(field.property);
      }
    });
  },
};
</script>
